module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("08:30")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Anna exhales, ‘Phew.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rain is thundering on the car roof, as if to underline their good fortune.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That was a stroke of luck,’ says the woman in the parka, pushing down her hood and wriggling out of her rucksack. She is compactly built and supple and seems practised at the manoeuvre. ‘That poor guy,’ she says, sitting back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What was it?’ asks Anna.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Heart attack,’ says the parka woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Did he die, do you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m afraid so.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, Lord.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I know, awful. He was travelling with his wife, too.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How do you know?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I was sitting next to them. The other side of the aisle.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Gosh. That must have been a horrible thing to witness.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ nods the parka woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And there I was, complaining that all this was just inconvenient, Anna castigates herself. The Goth was obviously right. What does it matter, really, if I’m a bit late for work? She voices her thoughts: ‘It’s not exactly how you’d choose to go, is it? You’d rather die flying a kite with your grandchildren, or at a great party or something. Not on the seven forty-four.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oi, ladies,’ the driver interrupts before she has a chance to continue. He is listening to a crackling and distorted voice over his radio. ‘No point going to Haywards Heath. Apparently the trains from there are at a standstill. Whole lot’s buggered.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They can’t do that, surely?’ asks Anna.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ooh, they can, believe me,’ says the driver. ‘You know what it’s like on the Brighton line – it’s a single track each way from Haywards Heath to the coast. Only takes one train to scupper it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The two women look at each other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The driver chivvies, ‘So where do you want me to take you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Home?’ suggests the parka woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where’s home?’ asks the other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Brighton,’ says the parka woman, then clarifies, ‘Kemptown.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna’s mind whirrs. Anorak, boyish face, cropped and gelled hair, no make-up, jeans, rucksack, Kemptown address: she’s gay. Kemptown is not that far from Anna’s house: it’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("so")]), _vm._v(" tempting, but – ‘I can’t,’ she explains. ‘I have to get to London.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I guess I should go too,’ agrees the parka woman. ‘Just quite nice to have an excuse for once.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ve got a meeting,’ says Anna.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What time’s it at?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ten.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna looks at her watch. It’s eight thirty-five now. ‘Typical, isn’t it?’ she says. ‘Normally the seven forty-four gets me to work fine.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But they’ll understand, won’t they?’ says the parka woman. ‘Someone has just died on board.’ She laughs, but it doesn’t seem unkind; rather it is a comment on the ludicrousness of their situation. She pauses, assessing. ‘Can’t you just ring and explain you’ll be late?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna imagines the bulldog stance of her boss in reception and isn’t so sure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ladies,’ the driver cuts in again. They are approaching traffic lights at a crossroads. ‘I need a decision. Where are you going?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna catches his eye in the mirror. She is sure he is smirking, enjoying this. ‘I really need to get to London,’ she reiterates. She doesn’t want to leave her colleagues in the lurch. Not to make it would compel one of them to present in her place – no fun at short notice, Anna knows. She leans forward, close to his ear. ‘How much to take us there?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Depends where.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wonders: where would suit her and hopefully the other woman, and not be too difficult in terms of rush hour traffic? ‘Clapham Junction?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where’s your meeting?’ asks the parka woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Cheyne Walk off the King’s Road – I can get lots of buses from the station.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Fine by me,’ agrees the parka woman. ‘I’ll get a train from Clapham up to Victoria.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll do it for seventy quid,’ says the driver. They’re stopped at traffic lights.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna does a rapid calculation. It’s not unreasonable for sixty miles or so. On her daily rate it is worth it – she will lose much more than that if she doesn’t show. She glances at the parka woman. She looks hesitant – Anna is aware that not everyone earns as much as she does.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m happy to pay fifty quid of it,’ she offers. ‘I really do need to get there.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, that wouldn’t be fair.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I get paid by the day,’ she explains. ‘So I’m fine to, honestly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you sure?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Um…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Really, it’s fine. I’d be paying it on my own otherwise.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘OK then. Thank you,’ the parka woman smiles, appreciative.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Great.’ Anna leans forward to the driver again. ‘Do it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So he flicks up the indicator, turns left and heads towards the motorway.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "46",
      "src": "Images/sp.jpg",
      "width": "103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("‘I guess I might as well introduce myself. I’m Lou.’ Lou turns to face the other woman and thrusts out her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her fellow passenger is not conventionally pretty, but she is striking nonetheless. She must be in her early forties – whereas Lou is ten years younger – and she has a strong, angular face with Cleopatra dark hair, styled poker-straight. Her make-up is bold: a gash of lipstick, dark shadow that makes no apology for deliberately intensifying brown eyes. It signals confidence, an effect compounded by her height and long limbs. She is slim and well dressed, in a smart navy trench coat, and her large snakeskin handbag looks expensive. The overall effect is of someone intelligent yet daunting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m Anna,’ she returns. Her hand is cold, bony; her grasp assured and firm. But she is generous and empathetic, Lou has noticed already; clearly she is not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" hard.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where are you going?’ Lou asks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I work in Chelsea. My meeting is at the office. You?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m on my way to Hammersmith.’ There is a moment’s silence. ‘I’m a youth worker,’ Lou adds.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah,’ Anna nods.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though she loves her job, Lou is conscious her profession is not particularly glamorous or well remunerated. Whilst she has no idea exactly what this woman who works off the King’s Road does, she supposes it’s far more high-flying, and somehow wants her approval. But she doesn’t get the chance to elaborate on why she does what she does because next Anna swivels her hips and tucks her left foot under her, so as to face Lou as fully as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So tell me,’ she urges. ‘What happened on the train?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou recounts the events as best she can remember.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘There simply wasn’t time for anyone to resuscitate him,’ Lou finishes. ‘The nurses were there in next to no time, and they tried…God knows they tried.’ She shivers, recollecting. ‘But it was over so fast. One minute he was drinking his coffee, the next, so it seems – gone.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The poor woman he was with!’ Anna says, aghast. ‘Just imagine that, leaving for work with your husband, thinking it was just a normal day, and then suddenly he keels over and dies. Right beside you. Oh, I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" feel sorry for her.’")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "46",
      "src": "Images/sp.jpg",
      "width": "103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("‘So do you live in Brighton too, then?’ asks Lou, once they’re on the motorway. The driver puts his foot down and soon they’re doing a steady seventy miles per hour. Gorse bushes just beginning to bud yellow flash by on the embankment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Seven Dials. You know it?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course,’ retorts Lou. ‘I’ve lived in Brighton for nearly ten years.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, well.’ This makes it worthwhile to be more precise. ‘I’m on Charminster Street.’ Lou looks blank. ‘Between Old Shoreham Road and Dyke Road.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, yeah!’ Lou exclaims. ‘Lovely little white Victorian houses, office block at the end of the street.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That’s it. It’s a bit scruffy, but I like it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Is it just you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sounds genuinely interested and Anna sees her glance at her finger – presumably to check if she is married. How funny, Anna thinks, we’re both looking for signals, assessing. Nonetheless, she pauses. It is not a subject on which she likes to be drawn. ‘Um, no…I live with my partner.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou picks up her cue, and changes the subject. ‘So, do you always work in London?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mostly, yes. You?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Four days a week. I wouldn’t want to commute the full five.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, it does get tiring.’ Anna experiences a flush of resentment: if Steve earned more, she wouldn’t need to travel so much. But she doesn’t say this. Instead she takes a deep breath and says, more positively: ‘I love being in Brighton though. So it is worth it.’ She smiles, thinking affectionately of the terraced home she has put so much time and energy into decorating, with its patio garden and views out over the Downs. Then there is her handful of close friends conveniently nearby; the Lanes, jostling with one-off shops and equally eclectic people; the steep shingle of the beach and beyond it, the sea…That, perhaps above all else, makes the commute worthwhile: the grey, the green and the blue of it; the crashing, the calm and the choppiness of it; the never-the-same-two-days-in-a-row of it: ah, the sea…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou interrupts her thoughts. ‘I like being in Brighton too.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So where are you in Kemptown?’ Anna asks. ‘I do hope you’re not going to tell me you’ve got a whole house on the seafront there!’ She is joking, of course: the Regency houses overlooking the beach in Kemptown are huge. Not merely that, they are magnificent; elegant cream stucco frontages, giant windows rising floor to ceiling, rooms of breathtaking proportions with marble fireplaces and elaborate plaster cornices – to own a whole one would be a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou laughs. ‘Hardly. I live in a little attic flat – it’s not much bigger than a studio really.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something about the way she uses ‘I’, not ‘we’, suggests Lou is living alone. Anna clarifies, ‘So I presume you don’t share?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lou laughs again. She has an infectious laugh: deep, throaty, uninhibited. ‘God no, there’s barely room to swing a cat.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And where is it, if you don’t mind my asking?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘On Magdalene Street.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ooh. Does that mean you can see the sea?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, from the living-room bay, down the bottom of the road. I think estate agents call it “an oblique sea view”. And I’ve got a tiny roof terrace where you can see the sea "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" the pier.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How lovely.’ Anna is wistful. She has always fantasized about having her own garret. Fleetingly, she imagines a different life for herself: one where she doesn’t have so many commitments; where there is no mortgage to pay, no Steve, and she is free to pursue her own creativity…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Enough of that: she can’t change it, and anyway, she wants to know more about Lou. ‘It must be great for nightlife round there,’ she says, hoping to prompt revelations. Lou lives in the heart of Brighton’s gay district and there are dozens of pubs and clubs at hand where Anna imagines all sorts of exciting things happen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sometimes a bit "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("too")]), _vm._v(" good,’ replies Lou. ‘It can get a bit noisy.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s a bit tame, thinks Anna. She’d wanted tales of wild drug-taking and lesbian threesomes. If her own existence is circumscribed these days, she can at least live vicariously. Then again, if there are interesting aspects to Lou’s life, she is hardly likely to confess all to a stranger in a taxi.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "46",
      "src": "Images/sp.jpg",
      "width": "103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Half an hour into the journey, Lou has decided that Anna seems OK, but is still unsure if they have much in common. Lou is a good judge of character on the whole; years of working as a counsellor have honed an innate skill, so she tends to assess individuals well. She is perhaps less shrewd when it comes to judging women she fancies, when sexual attraction can get in the way. But she has seen many straight women – and men too, come to that – make poor judgements when lust muddies perception, so at least she is not alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anyhow, Anna is clearly straight, and not Lou’s type physically. Nonetheless, she is intrigued. She loves nothing more than delving into people’s psyches; it is the same curiosity that has her watching strangers on the train, mapping out lives for them, piecing together the evidence. And it is also what drives her professionally; she loves getting to the bottom of what makes complex – though often tragically self-destructive – young people tick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In spite of Anna’s polished exterior, which suggests a more materialistic bent than Lou herself, Lou reckons there might be more to her than her travelling companion’s unruffled presentation suggests. There have been little signals, along the way. She has made no mention of any offspring, and most women would do, given the nature of the conversation they have been having about their respective homes. So Lou reckons she doesn’t have children, which is relatively unusual for a woman of her age. But more interesting is the way Anna hesitated before mentioning her partner; Lou reckons there is a story there. She is quick to pick up when someone is hiding something – not least because in certain situations, she does it herself. Plus there is the way Anna is sensitive to the needs of others, even when she is taking control. They did what Anna wanted ultimately, after all, yet she offered to pay Lou’s share. It hints at a sharp mind and a complex character, and Lou’s curiosity is piqued.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I wonder, she muses, as they pull off the M23 and onto the dual carriageway into the drab outskirts of Coulsdon, whether we’ll ever see each other after today? She’s used to journeying up to London on her own in the morning, using the space to gather her thoughts. Still, it would be nice to have someone to chat to from time to time, when she is in the mood. Maybe, if Anna is on the seven forty-four as often as she says she is, they will see each other on board. That said, it is a long train and always packed with people. Being on it at the same time is no guarantee their paths will cross again.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446c8cae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429938327_ch02.vue
// module id = 72
// module chunks = 0